import { Injectable } from '@angular/core';

import { ApiService } from '../core/upgraded-providers';
import { XPayStationWidgetService } from '../core/XPayStationWidget.service';

import { Subject, Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

const { XSOLLA_SANDBOX } = window.CONFIG;

@Injectable()
export class XsollaService {
    private _xpaySbj: Subject<any>;
    private _xpay$: Observable<any>;

    constructor(
        private _apiService: ApiService,
        private _XPayStationWidget: XPayStationWidgetService
    ) {
        this._reasssing();
    }

    private _reasssing() {
        this._xpaySbj = new Subject();
        this._xpay$ = this._xpaySbj.asObservable();
    }

    next(token, data) {
        const statusDoneCb = (evt) => {
            this._xpaySbj.next();
        };

        const statucCb = () => {
        };

        const closeCb = () => {
            this._xpaySbj.complete();

            this._XPayStationWidget.off('open', statucCb);
            this._XPayStationWidget.off('status-done', statusDoneCb);
            this._XPayStationWidget.off('close', closeCb);

            this._reasssing();
        };

        this._apiService
            .post(token, data)
            .then((data) => {
                this._XPayStationWidget.init({
                    access_token: data.token,
                    sandbox: XSOLLA_SANDBOX,
                    lightbox: {
                        zIndex: 1001
                    }
                });

                this._XPayStationWidget.on('open', statucCb);
                this._XPayStationWidget.on('status-done', statusDoneCb);
                this._XPayStationWidget.on('close', closeCb);

                this._XPayStationWidget.open();
            })
            .catch((err) => {
                this._xpaySbj.error(err);
            })
            .finally(() => {
                // Noop.
            });
    }

    subscribe(
        next?: (value: any) => void,
        error?: (error: any) => void,
        complete?: () => void
    ): Subscription {
        return this._xpay$
            .subscribe(next, error, complete);
    }

    subscribeOnComplete(cb: any): Subscription {
        return this._xpay$
            .pipe(finalize(cb))
            .subscribe();
    }
}
